import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { GetResponse } from "@/api/remind-count/response";
import * as RemindCountAPI from "@/api/remind-count";
import { isSuccess } from "@/api/response";
import { GetRequest } from "@/api/remind-count/request";

const MODULE_NAME = "remind-count/get";

/**
 * プッシュメッセージ定期自動配信設定対象ユーザー数取得API（/get-remind-count）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getResponse: GetResponse = {} as GetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getCount() {
    return this.getResponse.count;
  }

  // MutationActions
  @MutationAction
  async get(getRequest: GetRequest) {
    const getResponse = await RemindCountAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as GetResponse
    };
  }
}

export default getModule(Get);
